import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-frontend-game',
  templateUrl: './frontend-game.component.html',
  styleUrls: ['./frontend-game.component.scss']
})
export class FrontendGameComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
